import { InjectionToken } from "@angular/core";
import { UserDto } from "projects/shared/lib/services/INTEGRA_Shop_Client";

export abstract class IUserInformationSetDialogService {

  abstract userInformationSetDialogShow(
    modalTitle: string,
    callbackSubmit: () => void,
    callbackCancel: () => void,
    user: UserDto,
    submitButtonLabel?: string,
    cancelButtonLabel?: string,
  ): unknown;

}
/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IUserInformationSetDialogServiceToken = new InjectionToken<IUserInformationSetDialogService>('IUserInformationSetDialogServiceToken');
